import {
  initialState,
  Actions,
  State,
  GET_LAST_PERIODIC_CHECK,
  GET_LAST_PERIODIC_CHECK_SUCCESS,
  GET_LAST_PERIODIC_CHECK_ERROR,
  RESET_GET_LAST_PERIODIC_CHECK,
} from '../../types/periodic-check/get-last'

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case GET_LAST_PERIODIC_CHECK:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      }
    case GET_LAST_PERIODIC_CHECK_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      }
    case GET_LAST_PERIODIC_CHECK_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: action.payload,
          success: false,
        },
      }
    case RESET_GET_LAST_PERIODIC_CHECK:
      return initialState
    default:
      return state
  }
}

export default reducers
